import api from './api';
import type { EmendaDTO } from './emendaService';

export interface EmendaDevolvidaDTO {
  id: string;
  officialCode?: string;
  description?: string;
  value?: number;
  motivoDevolucao?: string;
  dataDevolucao?: string;
  statusCicloVida?: string;
  councilorId?: string;
  councilorName?: string;
  exercicio?: number;
  usuarioCiencia?: string;
  dataCiencia?: string;
  councilorSituacaoExcepcional?: boolean;
  redistribuidaPara?: string | null;
}

export interface SaldoParlamentarDTO {
  parlamentarId: string;
  parlamentarNome?: string;
  limiteAnual: number;
  totalEmpenhadoAtivo: number;
  saldoDisponivel: number;
  ano: number;
  totalEmendasAtivas?: number;
  totalRedistribuidoRecebido?: number;
}

export interface CamaraAreaTrabalhoDTO {
  pendenteCiencia: EmendaDevolvidaDTO[];
  comCiencia: EmendaDevolvidaDTO[];
  saldos: SaldoParlamentarDTO[];
}

export const camaraAreaTrabalhoService = {
  getAreaTrabalho: async (): Promise<CamaraAreaTrabalhoDTO> => {
    const res = await api.get('/camara/area-trabalho');
    return res.data;
  },

  registrarCiencia: async (emendaId: string): Promise<EmendaDevolvidaDTO> => {
    const res = await api.post(`/camara/area-trabalho/ciencia/${emendaId}`);
    return res.data;
  },

  redistribuir: async (
    emendaId: string,
    payload: { parlamentarDestinoId: string; observacao?: string }
  ): Promise<EmendaDevolvidaDTO> => {
    const res = await api.post(`/camara/area-trabalho/redistribuicao/${emendaId}`, payload);
    return res.data;
  },

};

export default camaraAreaTrabalhoService;